import moment from 'moment';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import PathwayInviteCandidatesView from './pathway_invite_candidates_view';
import { getPathwayInstance, getCurrentUser } from '../../../../reducer';
import { bulkCreateCandidatePathways } from '../../../../solve/actions';

const buildInitialValues = () => fromJS({ startDate: moment(0, 'HH').toDate() });

const buildSubmitValues = (formValues) => ({
  startsOn: formValues.get('startDate'),
  candidate_ids: formValues.get('candidates').keySeq().toList(),
  pathwayInstanceStepsAttributes: Object.entries(formValues.get('pathwayStepDates').toJS()).map((step) => ({
    pathwayStepId: step[0],
    targetCompletionDate: step[1],
  })),
});

const mapStateToProps = (
  state,
  {
    match: {
      params: { id },
    },
  },
) => {
  const pathwayInstance = id && getPathwayInstance(state, id);

  return {
    initialValues: buildInitialValues(),
    currentUser: getCurrentUser(state),
    pathwayInstance,
  };
};

const mapDispatchToProps = {
  getPathwayInstance,
  bulkCreateCandidatePathways,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  handleSubmit: (formValues) => {
    const values = buildSubmitValues(formValues);
    return dispatchProps.bulkCreateCandidatePathways(stateProps.currentUser, stateProps.pathwayInstance.get('id'), values);
  },
  // listAllCandidates: () => dispatchProps.listAllCandidates(stateProps.currentUser, stateProps.organizationId),
  // listAllCandidates: () => dispatchProps.listAllCandidates(stateProps.currentUser, stateProps.organizationId),
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
});

const PathwayInviteCandidatesContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(PathwayInviteCandidatesView);

export default PathwayInviteCandidatesContainer;
